import { InitialTouchPoint } from '../../api/models';
import {
  createAction,
  createActionWithPayload,
  IAction,
  IActionWithPayload,
} from '../utils';

const ACTION_LOAD_INITIAL_TOUCH_POINT_REQUEST =
  'ENTITIES/LOAD_INITIAL_TOUCH_POINT_REQUEST';
const ACTION_LOAD_INITIAL_TOUCH_POINT_SUCCESS =
  'INTENT/LOAD_INITIAL_TOUCH_POINT_SUCCESS';
const ACTION_LOAD_INITIAL_TOUCH_POINT_ERROR =
  'INTENT/LOAD_INITIAL_TOUCH_POINT_ERROR';

export interface InitialTouchPointState {
  initialTouchPoint: InitialTouchPoint[];
  isLoading?: boolean;
  isLoaded?: boolean;
}

const initialState: InitialTouchPointState = {
  initialTouchPoint: [],
  isLoaded: false,
  isLoading: false,
};

type InitialTouchPointRequestActionType = IAction<
  typeof ACTION_LOAD_INITIAL_TOUCH_POINT_REQUEST
>;

type InitialTouchPointSuccessActionType = IActionWithPayload<
  typeof ACTION_LOAD_INITIAL_TOUCH_POINT_SUCCESS,
  InitialTouchPoint[]
>;

type InitialTouchPointErrorActionType = IAction<
  typeof ACTION_LOAD_INITIAL_TOUCH_POINT_ERROR
>;

type Actions =
  | InitialTouchPointRequestActionType
  | InitialTouchPointSuccessActionType
  | InitialTouchPointErrorActionType;

export const loadInitialTouchPointRequestAction = (): InitialTouchPointRequestActionType => {
  return createAction(ACTION_LOAD_INITIAL_TOUCH_POINT_REQUEST);
};

export const loadInitialTouchPointSuccessAction = (
  data: InitialTouchPoint[]
): InitialTouchPointSuccessActionType => {
  return createActionWithPayload(ACTION_LOAD_INITIAL_TOUCH_POINT_SUCCESS, data);
};

export const loadInitialTouchPointErrorAction = (): InitialTouchPointErrorActionType => {
  return createAction(ACTION_LOAD_INITIAL_TOUCH_POINT_ERROR);
};

// reducer
export const initialTouchPointReducer = (
  state: InitialTouchPointState = initialState,
  action: Actions
): InitialTouchPointState => {
  switch (action.type) {
    case ACTION_LOAD_INITIAL_TOUCH_POINT_REQUEST:
      return {
        ...state,
        isLoading: true,
        isLoaded: false,
      };
    case ACTION_LOAD_INITIAL_TOUCH_POINT_ERROR:
      return {
        ...state,
        isLoaded: true,
        isLoading: false,
      };
    case ACTION_LOAD_INITIAL_TOUCH_POINT_SUCCESS:
      return {
        ...state,
        initialTouchPoint: action.payload,
        isLoading: false,
        isLoaded: true,
      };
    default:
      return state;
  }
};
